import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@mui/material';

const MonthPicker = ({ value, onChange }) => {
  return (
    <TextField
      type="month"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      size="small"
      sx={{
        bgcolor: 'white',
        boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
        borderRadius: 1,
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: '#ddd',
          },
        },
      }}
    />
  );
};

MonthPicker.propTypes = {
  value: PropTypes.string.isRequired, // Format: 'YYYY-MM'
  onChange: PropTypes.func.isRequired,
};

export default MonthPicker;
